module.exports = __webpack_public_path__ + "img/恢复2.75d692c6.svg";